import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom'
import queryString from 'query-string';

import { auth } from '../../utils/sessions';
import { LoaderLayout } from '../layouts';

class PrivateRoute extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pending: true,
            loggedInStatus: false
        };
    }

    componentWillMount() {
        const parsed = queryString.parse(this.props.location.search);
        auth.isAuthenticated(parsed.token);
        this.setState({'pending': false});
    }

    renderPendingOrRedirect() {
        if (this.props.loggedInStatus === 'pending') {
            return <LoaderLayout />;
        }
        else {
            return <Redirect to={{
                pathname: '/error',
                state: {from: this.props.location}
            }}/>

        }
    }

    render() {
        const {component: Component, ...rest} = this.props;
        return (

            <Route {...rest} render={props => {

                return this.props.loggedInStatus === true
                    ? <Component {...props} />
                    : this.renderPendingOrRedirect()
            }}/>

        );
    }
}

function mapStateToProps(state) {
    return {
        loggedInStatus: state.loggedInStatus,
        user: state.user
    };
}

export default connect(mapStateToProps)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/components/generic/PrivateRoute.jsx